import { InvitedPerson, ParsedPerson, StatusEnum } from './types';

const setState = (state: string) => {
  switch (state) {
    case StatusEnum.STATE_CREATED:
      return 'получил приглашение';
    case StatusEnum.STATE_ACTIVE:
      return 'активный пользователь';
    case StatusEnum.STATE_CANCELLED:
      return 'приглашение отклонено';
    default:
      return 'статус не определен';
  }
};

const parsePerson = (data: InvitedPerson): ParsedPerson => ({
  fio: data!.invited_fio || 'Без имени',
  state: setState(data.state),
  email: data!.email || '',
});

export default parsePerson;



// WEBPACK FOOTER //
// ./src/services/invite/utils/parsePerson.ts